import { isNumber } from 'lodash-es';

/**
 * Returns true if the given location has valid latitude and longitude (not null or undefined).
 */
export function isValidLatLngLocation(location: { latitude?: number | null; longitude?: number | null } | null | undefined): boolean {
  return isNumber(location?.latitude) && isNumber(location?.longitude);
}
